export default "__VITE_ASSET__D$lyb09D__"